import e, { useRef as _, useState as a, useCallback as o, useEffect as t } from "react";
var b = function () {
  return b = Object.assign || function (e) {
    for (var _, a = 1, o = arguments.length; a < o; a++) for (var t in _ = arguments[a]) Object.prototype.hasOwnProperty.call(_, t) && (e[t] = _[t]);
    return e;
  }, b.apply(this, arguments);
};
var d = {
    "Desktop/005_B_Spot/005a_B_Spot_01": "Desktop/005_B_Spot/005a_B_Spot_01-b42e74e23c710301be78d2466952f633ea2d3f339dab30a5a88571e1c0fd0221.mp4",
    "Desktop/001_B_Box/001_B_Box_01": "Desktop/001_B_Box/001_B_Box_01-4384cb4c740a99cf0ca85103906bc115acd3061053f3584fa52b4c32b1e732b8.mp4",
    "Desktop/001_B_Box/001c_Lautsprecher_02": "Desktop/001_B_Box/001c_Lautsprecher_02-8455b828323c7c167e67eb55521042ccf3206e1b65ad36054f04f09fb144159a.mp4",
    "Desktop/001_B_Box/001b_Wandhalterung_01": "Desktop/001_B_Box/001b_Wandhalterung_01-67e2423dae967511e222d6f7e5c7e6f59743df2e4e6cbd7b9112b7758fcaa38e.mp4",
    "Desktop/001_B_Box/001a_Fuesse_03": "Desktop/001_B_Box/001a_Fuesse_03-71c7dfa004f5d679e66c3eba2f93f60e10dbe6ca08324e416c772a55e07829fb.mp4",
    "Desktop/001_B_Box/001d_Ambiente_01": "Desktop/001_B_Box/001d_Ambiente_01-3710a5e840075597bc2a713c87fb4886e1404967d91ee8ef9693ad6cdcd56dcc.mp4",
    "Desktop/003_B_Bed/003c_Feuchtigkeit_01": "Desktop/003_B_Bed/003c_Feuchtigkeit_01-46e7a18077a3a858347c19442c5917c9c50cdfba60565259735d4af6b1d4ef38.mp4",
    "Desktop/003_B_Bed/003a_Beauty_01": "Desktop/003_B_Bed/003a_Beauty_01-bcb1e93e87b7efaefa938e67b6174ec454c411682773b325bc3fc2b78ede3bb1.mp4",
    "Desktop/003_B_Bed/003b_Sandwich_02": "Desktop/003_B_Bed/003b_Sandwich_02-ecaefa55864240bfbe20f3b02cceb26355c179b492e5c3efc1e3067292e52b14.mp4",
    "Desktop/003_B_Bed/003d_Beauty_02": "Desktop/003_B_Bed/003d_Beauty_02-9e698fee00e4cba801ae33b62b9aa0339cc58721ac4cd9b97c9f1eaeeed7cf6d.mp4",
    "Desktop/004_B_Pad/004c_Verlaengerung_02": "Desktop/004_B_Pad/004c_Verlaengerung_02-a29c9d565f456c18e400e5c5997b5ce30d22fab6e8a6977660c44d0adab730fe.mp4",
    "Desktop/004_B_Pad/004b_Ausrollen_01": "Desktop/004_B_Pad/004b_Ausrollen_01-6754a8a3a3b970e331f9f6e9d7a0765fe6caff691ae9de045bbab2bbf36ea0bd.mp4",
    "Desktop/004_B_Pad/004a_Beauty_01": "Desktop/004_B_Pad/004a_Beauty_01-f1a4bc50700ba35cd43582beb4d257810c4e1bbdd05c551fc3781735aef4fd41.mp4",
    "Desktop/006_B_Light/006a_B_Light_Clear_01": "Desktop/006_B_Light/006a_B_Light_Clear_01-883d1560f430aeaed51b3f29529321762633cab23b266270b33690528ee472b5.mp4",
    "Desktop/006_B_Light/006b_B_Light_Restore_01": "Desktop/006_B_Light/006b_B_Light_Restore_01-57b9418b98d04eabb6d363aaaf4a94bda10aafe44aff9569b953947fad129ef8.mp4",
    "Desktop/002_B_Body/002c_Magnetfelder_01": "Desktop/002_B_Body/002c_Magnetfelder_01-1dbff96e4ace2f5397907b0223112a463148a01cc7ad6b07d2dbce89a20ef7c0.mp4",
    "Desktop/002_B_Body/002a_Beauty_01": "Desktop/002_B_Body/002a_Beauty_01-5b1fa6a2855eea9387b5320f490c142c65f9163815649599a08b2eb8d96e41f0.mp4",
    "Desktop/002_B_Body/002d_Falten_01": "Desktop/002_B_Body/002d_Falten_01-b6a7c841b0760090fbb30550d66a3b3bddd09bce413b85ef52c23bd3b5f7e215.mp4",
    "Desktop/002_B_Body/002b_Sandwich_01": "Desktop/002_B_Body/002b_Sandwich_01-8b5cc58ffe052d465608995637229ce2b4c9ed61143042b10a8d2259a3d88244.mp4",
    "Mobile/005_B_Spot/005a_B_Spot_Mobile_01": "Mobile/005_B_Spot/005a_B_Spot_Mobile_01-27d82b68a11ff98202aa273ec4d019ca79c3efaec11f320b9f5cbe3513f51b19.mp4",
    "Mobile/001_B_Box/001a_Fuesse_Mobile_03": "Mobile/001_B_Box/001a_Fuesse_Mobile_03-fae223fbe9f4835c761080f75f90dfc254f3ce1a2f85276b6479c8e8918d0535.mp4",
    "Mobile/001_B_Box/001b_Wandhalterung_mobile_01": "Mobile/001_B_Box/001b_Wandhalterung_mobile_01-83cc6ad49631dc74031757773b3db217c9b61f4af05d734d317fc37573f83cd8.mp4",
    "Mobile/001_B_Box/001d_Ambiente_mobile_01": "Mobile/001_B_Box/001d_Ambiente_mobile_01-c2ef4cfeaaad8fd982929bff2f6b8a6c836a159ed14b90bed9d89bbcee76fd50.mp4",
    "Mobile/001_B_Box/001c_Lautsprecher_mobile_02": "Mobile/001_B_Box/001c_Lautsprecher_mobile_02-d04e0cc90b463ad029dc38fe0385003367b2020ce89d7dbbe3992f5b086aa515.mp4",
    "Mobile/001_B_Box/001_B_Box_mobile_01": "Mobile/001_B_Box/001_B_Box_mobile_01-1b93b7b92d14dd9214e76602bdc156e06e6d5c37f125acb38ac0ded878ac7fbe.mp4",
    "Mobile/003_B_Bed/003d_Addon_Beauty_Mobile_01": "Mobile/003_B_Bed/003d_Addon_Beauty_Mobile_01-b760530a841a5dbbbf9e7a5a78c1e660f7e98a64fff9e544e16daac5ec03f2d5.mp4",
    "Mobile/003_B_Bed/003c_Feuchtigkeit_Mobile_01": "Mobile/003_B_Bed/003c_Feuchtigkeit_Mobile_01-ea56752b7554d146c68164081e377647def934b257577603718cf40660760c14.mp4",
    "Mobile/003_B_Bed/003a_Beauty_Mobile_01": "Mobile/003_B_Bed/003a_Beauty_Mobile_01-d576ca859ebfb8dd89218a817306a4a6a1c80c831e70f03a3e145deee458e646.mp4",
    "Mobile/003_B_Bed/003b_Sandwich_Mobile_02": "Mobile/003_B_Bed/003b_Sandwich_Mobile_02-8b66bf2225d84f16e9eec79fd0a6e689a2fe7c2dd5fc674bb1359ce1ba8655de.mp4",
    "Mobile/004_B_Pad/004a_Beauty_Mobile_01": "Mobile/004_B_Pad/004a_Beauty_Mobile_01-8323962e49478b0380a95fadba3bd3ff1b5f922fa92365b3c397ee2849a2f1c7.mp4",
    "Mobile/004_B_Pad/004b_Ausrollen_Mobile_01": "Mobile/004_B_Pad/004b_Ausrollen_Mobile_01-f817483c73bdebbbd7b2916e079c935999474ef45c4e09ed984a85bd75c76c5e.mp4",
    "Mobile/004_B_Pad/004c_Verlaengerung_Mobile_02": "Mobile/004_B_Pad/004c_Verlaengerung_Mobile_02-9dc96a1a1f2c2ceb0f00bad89559f8feac6aced863c9b62160b5d2d9638c8ded.mp4",
    "Mobile/006_B_Light/006a_B_Light_Clear_Mobile_01": "Mobile/006_B_Light/006a_B_Light_Clear_Mobile_01-a45fd1bbb716f4ae68c019e5d50932b5033770d8329dfb23e51c839fdab78a55.mp4",
    "Mobile/006_B_Light/006b_B_Light_Restore_Mobile_01": "Mobile/006_B_Light/006b_B_Light_Restore_Mobile_01-18705f93e845a02b9f62fbeb9545ae5476977d67a287a7cf0be7ca711abf8a25.mp4",
    "Mobile/002_B_Body/002c_Magnetfelder_Mobile_01": "Mobile/002_B_Body/002c_Magnetfelder_Mobile_01-e79c40471291e0ae9325521e5ed53749bf2da77c63f65d2d832b9e2a5ed39050.mp4",
    "Mobile/002_B_Body/002a_Beauty_Mobile_02": "Mobile/002_B_Body/002a_Beauty_Mobile_02-376dd5bc52d606700585072d2bbd17404d1c684c21176e1ff46bda4e45ba9270.mp4",
    "Mobile/002_B_Body/002d_Falten_Mobile_01": "Mobile/002_B_Body/002d_Falten_Mobile_01-6a1d522a640bb92a05d802134e4ae99e85e999a552a51669180319914f6290b3.mp4",
    "Mobile/002_B_Body/002b_Sandwich_Mobile_01": "Mobile/002_B_Body/002b_Sandwich_Mobile_01-e32deabcda11eb6101fd1016dfb5016a6471b00022fa158315117725b2644d2a.mp4"
  },
  c = function (c) {
    var i,
      r,
      n = c.scrollElementProps,
      l = function (e, _) {
        var a = {};
        for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && _.indexOf(o) < 0 && (a[o] = e[o]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var t = 0;
          for (o = Object.getOwnPropertySymbols(e); t < o.length; t++) _.indexOf(o[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[t]) && (a[o[t]] = e[o[t]]);
        }
        return a;
      }(c, ["scrollElementProps"]),
      f = _(null),
      B = _(null),
      p = _(null),
      s = a(!1),
      u = s[0],
      m = s[1];
    if (l.video && void 0 === d[l.video]) throw new Error('Specified video "'.concat(l.video, '" not found'));
    if (l.video && l.videoUrl) throw new Error('Specified both "video" and "vieoUrl". Please specify only one of them.');
    var h = o(function () {
      if (f.current && p.current) {
        var e = f.current.getBoundingClientRect();
        if (p.current.style.width = "".concat(e.width, "px"), p.current.style.height = "".concat(window.innerHeight, "px"), e.top > window.innerHeight ? p.current.style.opacity = "0" : e.top > 0 ? (p.current.style.opacity = "1", p.current.style.transform = "translate(".concat(e.left, "px, ").concat(e.top, "px)")) : e.bottom > window.innerHeight ? (p.current.style.opacity = "1", p.current.style.transform = "translate(".concat(e.left, "px, 0)")) : e.bottom > 0 ? (p.current.style.opacity = "1", p.current.style.transform = "translate(".concat(e.left, "px, ").concat(e.bottom - window.innerHeight, "px)")) : p.current.style.opacity = "0", B.current && B.current.readyState >= 2 && B.current.duration) {
          var _ = f.current.getBoundingClientRect(),
            a = Math.min(Math.max(-_.top, 0), _.height - document.documentElement.clientHeight) / (_.height - document.documentElement.clientHeight);
          B.current.currentTime = B.current.duration * a;
        }
      }
    }, []);
    t(function () {
      !u && B.current && B.current.play().then(function () {
        B.current && (B.current.pause(), h(), m(!0));
      });
    }, [u]);
    var M,
      y = _(null !== (i = l.video) && void 0 !== i ? i : l.videoUrl);
    return (l.video && y.current !== l.video || l.videoUrl && y.current !== l.videoUrl) && (y.current = null !== (r = l.video) && void 0 !== r ? r : l.videoUrl, m(!1)), t(function () {
      if (u) return window.addEventListener("scroll", h), window.addEventListener("resize", h), h(), function () {
        window.removeEventListener("scroll", h), window.removeEventListener("resize", h);
      };
    }, [u, h]), e.createElement("div", b({}, n, {
      ref: (null == n ? void 0 : n.ref) ? (M = [f, n.ref], e => {
        M.forEach(_ => {
          "function" == typeof _ ? _(e) : null != _ && (_.current = e);
        });
      }) : f
    }), e.createElement("div", {
      ref: p,
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        willChange: "opacity, transform, width, height",
        opacity: 0
      }
    }, e.createElement("div", {
      style: {
        width: "100%",
        height: "100%",
        position: "relative"
      }
    }, e.createElement("video", {
      playsInline: !0,
      disableRemotePlayback: !0,
      ref: B,
      width: "100%",
      height: "100%",
      style: {
        objectFit: "contain",
        visibility: u ? void 0 : "hidden"
      },
      src: l.video ? "https://storage.googleapis.com/bemer-charity.appspot.com/scroll-animation/".concat(d[l.video]) : l.videoUrl,
      muted: !0,
      preload: "auto"
    }))));
  };
export { c as ScrollAnimation };